<template>
  <VaDropdown :offset="[13, 0]" class="notification-dropdown" stick-to-edges :close-on-content-click="false">
    <template #anchor>
      <VaButton preset="secondary" color="textPrimary">
        <VaIconNotification class="notification-dropdown__icon" />
      </VaButton>
    </template>
    <VaDropdownContent class="h-full sm:max-w-[420px] sm:h-auto">
      <section class="sm:max-h-[320px] p-4 overflow-auto">
        <div class="text-center py-8">
          <VaIcon name="notifications_none" size="large" color="secondary" class="mb-4" />
          <h3 class="text-lg font-semibold text-secondary mb-2">{{ t('notifications.noNotifications.title') }}</h3>
          <p class="text-sm text-secondary opacity-70">{{ t('notifications.noNotifications.message') }}</p>
        </div>
      </section>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import VaIconNotification from '../../../icons/VaIconNotification.vue'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.notification-dropdown {
  cursor: pointer;

  .notification-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
